export default __webpack_public_path__ + "static/media/ios@2x.d76afc65.png";